import {
	Component,
	ComponentFactoryResolver,
	ComponentRef,
	Input,
	OnDestroy,
	OnInit,
	Type,
	ViewChild,
	ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'ws-wrapper',
	template: ` <ng-container #componentContainer></ng-container> `,
})
export class WrapperComponent implements OnInit, OnDestroy {
	@ViewChild('componentContainer', { read: ViewContainerRef, static: true })
	componentContainer!: ViewContainerRef;

	@Input() componentType?: Type<any>;

	@Input() componentInputs: { [key: string]: any } = {};
	protected componentRef!: ComponentRef<any>;

	constructor(protected route: ActivatedRoute, protected componentFactoryResolver: ComponentFactoryResolver) {}

	get passedComponentInputs() {
		return this.componentInputs;
	}

	set passedComponentInputs(value: { [key: string]: any }) {
		this.componentInputs = value;
	}

	ngOnInit(): void {
		this.createComponent(this.componentType);
	}

	ngOnDestroy(): void {
		this.destroyComponent();
	}

	public recreateComponent(newComponentInputs?: { [key: string]: any }): void {
		if (newComponentInputs) {
			this.componentInputs = newComponentInputs;
		}
		this.createComponent(this.componentType);
	}

	protected createComponent(componentType: any): void {
		this.destroyComponent();

		if (!componentType) {
			return;
		}

		const factory = this.componentFactoryResolver.resolveComponentFactory(componentType);
		this.componentRef = this.componentContainer.createComponent(factory);

		// Set inputs on the dynamic component
		for (const key in this.passedComponentInputs) {
			if (this.passedComponentInputs.hasOwnProperty(key)) {
				this.componentRef.instance[key] = this.passedComponentInputs[key];
			}
		}

		// If the component has a wrapper reference setter, provide it
		if (this.componentRef.instance.setWrapperRef) {
			this.componentRef.instance.setWrapperRef(this);
		}
	}

	protected destroyComponent(): void {
		if (this.componentRef) {
			this.componentRef.destroy();
		}
	}
}
